<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["BirimId", "DonemId", "Sorgulama","AltDonemId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      RiskDegerler :[],
      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi:[],
      donem_yili:"",
      deger: "",
      aciklama: "",
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
    TabloId(){
      this.Get();
    }
  },

  methods: {



    Get() {
      this.bugun = new Date();
      //alert(this.bugun);
      this.RiskDegerler = [];
    
    let Filter = "&Donemid="+this.DonemId+"&Gerceklesmedonemid=" + this.AltDonemId+"&Risktipi=1";

    if(this.BirimId!=null && this.BirimId!=""){
        Filter= Filter+"&BirimId="+this.BirimId;
    }
                     
    this.ActionsFilterGet({ Service: "StrRaporlama/GetKurumsalRiskRaporu", Page: this.Page, Filter: Filter }).then((res) => {
      this.RiskDegerler = res.Data;
      console.log( this.RiskDegerler)
      this.RiskDegerler.sort(this.buyuktenKucugeSiralama)
            
    });


    },
    buyuktenKucugeSiralama(a, b) { 
          return b.Etki*b.Olasilik - a.Etki*a.Olasilik;
      },
      renk(Data){
        if(0 < Data < 26){
          return 'yellow'
        }
        if(25 < Data < 65){
          return 'green'
        }
        if(64 < Data){
          return 'red'
        }
      },

        ExcelExport(table, name){  
           
                if (!table.nodeType) table = this.$refs.kurumsalriskraporu;
                var html =table.innerHTML  
                var ctx = {worksheet: name || 'Worksheet', table:html }
                var a = document.createElement('a');
                a.href = this.uri +this.base64(this.format(this.template, ctx));
                a.download = name + '.xls';
                a.click();  
        
  
      }, 




  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
  <div>
        <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="
                ExcelExport(
                  'Kurumsal Risk Raporu',
                  'Kurumsal Risk Raporu',
                )
              "
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
        </div>




  
    <div ref="kurumsalriskraporu" class="table-responsive">
      

    <div class="table-responsive">
      <table style="width:100%">
        <tr>
          <td colspan="13" style="text-align: center;">
              <div> <h4> Kurumsal Risk Raporu</h4></div>
          </td>
        </tr>

    
    </table>
    <br>


    <table style="border: 1px solid; border-collapse: collapse; " border="1" class="table  table-md table-bordered border-success mb-0"  >

      <thead class="table-light" style="text-align: center;">

       <tr style="text-align: center; font-weight: bold;">
        <th>Sıra</th>
        <th>Stratejik Hedef</th>
        <th>Birim / Alt Birim Hedefi</th>
        <th>Tespit Edilen Risk</th>
        <th>Riske Verilen Cevaplar / Mevcut Kontroller</th>
        <th>Etki</th>
        <th>Olasılık</th>
        <th>Risk Puanı (R)</th>
        <th>Değişim (Riskin Yönü)</th>
        <th>Riske Verilecek Cevaplar</th>
        <th>Başlangıç Tarihi</th>
        <th>Riskin Sahibi</th>
        <th>Açıklamalar</th>
       </tr>
      </thead>
      <tbody  v-for="(Data,index) in RiskDegerler" :key="index">
      <tr>
        <td>{{index+1}}</td>
        <td>{{Data.Stratejik_hedef}}</td>
        <td>{{Data.Birim_hedefi}}</td>
        <td>{{Data.Tespit_edilen_risk}}</td>
        <td>{{Data.Riske_verilen_cevaplar}}</td>
        <td>{{Math.round(Data.Etki)}}</td>
        <td>{{Math.round(Data.Olasilik)}}</td>
        <td class="text-center" :style="{background: renk(Math.round(Math.round(Data.Etki)*Math.round(Data.Olasilik))) } "><span style="color: black">{{Math.round(Math.round(Data.Etki)*Math.round(Data.Olasilik))}}</span></td>
        <td></td>
        <td>{{Data.Riske_verilen_cevaplar}}</td>
        <td>{{Data.Baslangic_tarihi | formatDateTable}}</td>
        <td>{{Data.Riskinsahibi}}</td>
        <td>{{Data.Aciklama}}</td>
      </tr>
      
    </tbody>
    </table>
    
    </div>
    
    </div>
  </div>
</template>
